import React from 'react';
import {
  Avatar, Box, Grid, Stack, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import appColors from 'common/app_colors';
import TeamDetailsBackrPair from './TeamDetailsBackrPair';

const defaultProfileImage = '/assets/profile/default-profile-image.svg';

// Two stored rows for one user with different kinds are permitted by the api
// and read together on /users/teams; the kind is what separates them.
const rowKey = (row) => `${row?.related_user_id}-${row?.relationship}`;

const TeamDetailsView = ({ protege = {
    first_name: '',
    last_name: '',
    role: '',
    profile_image: null,
  }, backrs }) => {
  const history = useHistory();
  const backrPairs = backrs.reduce((result, value, index, array) => {
    if (index % 2 === 0) { result.push(array.slice(index, index + 2)); }
    return result;
  }, []);
  const [firstPair, ...otherPairs] = backrPairs;

  const linkToProtege = (user) => {
    history.push(`/profile/${user.id}`);
  };

  const displayPanelRole = (roles = []) => {
    if (roles.some((role) => role?.name === 'Scholar')) {
      return 'Scholar';
    }
    if (roles.some((role) => role?.name === 'Student' || role?.name === 'Foundations')) {
      return 'Student';
    }
    return 'User';
  };

  const isStudentOrScholar = protege?.roles?.some((role) => role?.name === 'Student' || role?.name === 'Scholar' || role?.name === 'Foundations');

  return (
    <Box sx={{ width: 1, maxWidth: 375, mx: 'auto' }}>
      <Stack alignItems="center" mb={1.5} onClick={() => linkToProtege(protege)}>
        <Avatar
          className="ph-no-capture"
          src={protege?.profile_image}
          sx={{
            width: 108,
            height: 108,
            fontSize: 60,
          }}
        >
          <img src={defaultProfileImage} alt="profile" />
        </Avatar>
        <Box
          sx={{
            position: 'relative',
            top: -12,
            width: '100%',
            maxWidth: 108,
            background: isStudentOrScholar ? appColors.container.electricBlue : appColors.container.darkNavy,
            py: 0.35,
            borderRadius: 2,
            zIndex: 10,
          }}
        >
          <Stack spacing={-0.5}>
            <Typography
              align="center"
              sx={{ color: '#fff', fontSize: 13, fontWeight: 700 }}
            >
              {protege?.first_name && protege?.last_name
                ? `${protege?.first_name} ${protege?.last_name.charAt(0)}.`
                : 'Me'}
            </Typography>
            {protege?.roles && (
              <Typography
                align="center"
                sx={{ color: '#fff', fontSize: 10, fontWeight: 700 }}
              >
                {displayPanelRole(protege.roles)}
              </Typography>
            )}
          </Stack>
        </Box>
      </Stack>
      <Grid container>
        {firstPair ? (
          <>
            <TeamDetailsBackrPair protegeName={protege?.first_name} backrPair={firstPair} first />
            {otherPairs.length > 0
              ? otherPairs?.map((pair) => (
                <TeamDetailsBackrPair
                  key={`${rowKey(pair[0])}&${rowKey(pair[1])}`}
                  protegeName={protege?.first_name}
                  backrPair={pair}
                />
              ))
              : null}
          </>
        ) : null}
      </Grid>
    </Box>
  );
};

TeamDetailsView.propTypes = {
  protege: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    role: PropTypes.string,
    profile_image: PropTypes.string,
  }),
  backrs: PropTypes.arrayOf(
    PropTypes.shape({
      related_user_id: PropTypes.number,
      relationship: PropTypes.string,
      updated_at: PropTypes.string,
      related_profile: PropTypes.shape({
        id: PropTypes.number,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        profile_image: PropTypes.string,
      }),
    }),
  ).isRequired,
};


export default TeamDetailsView;
